import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-600);
`;
export const Description = styled.p `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  line-height: 1.5;
  margin: 0;
`;
export const GridContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-500);
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
export const GroupContainer = styled.div `
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  background-color: var(--bg-secondary);
  display: flex;
  flex-direction: column;
`;
export const GroupHeader = styled.div `
  margin-bottom: var(--space-400);
  line-height: 1.4;
`;
export const GroupTitle = styled.h4 `
  margin: 0 0 var(--space-100) 0;
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
`;
export const GroupDescription = styled.p `
  margin: 0;
  font-size: var(--font-size-200);
  color: var(--text-secondary);
  line-height: 1.4;
`;
export const TypesContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
  margin-top: auto;
  padding-top: var(--space-400);
`;
export const ReadWriteContainer = styled.div `
  display: flex;
  gap: var(--space-300);
`;
export const ReadWritePair = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-200);
`;
export const ReadWriteLabel = styled.span `
  font-size: var(--font-size-300);
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
`;
export const ButtonContainer = styled.div `
  display: flex;
  justify-content: flex-end;
  margin-top: var(--space-600);
`;
